import React from 'react';
import { Card, Col, Row, Badge } from 'react-bootstrap';
import Flex from 'components/common/Flex';

const PatientViewHeader = ({ patientDetails }) => {
    return (
        <Card.Header className="bg-info py-3">
            <Row className="align-items-center">
                <Col>
                    <Flex alignItems="center">
                        <img
                            src="/test-img.png"
                            alt="Patient"
                            className="img-fluid rounded-circle border"
                            style={{
                                width: "75px",
                                height: "75px",
                                objectFit: "cover",
                                border: "3px solid #2c7be5",
                                marginRight: "16px"
                            }}
                        />
                        <div>
                            <h4 className="mb-0 text-white fw-bold">
                                {patientDetails.patient_firstname} {patientDetails.patient_fathername} {patientDetails.patient_familyname}
                            </h4>
                            <div className="text-white opacity-75 fs-11">
                                <Badge bg="white" text="primary" className="me-2">MRN: {patientDetails.patient_mrn}</Badge>
                                <span className="me-2 text-white">|</span>
                                <span>{patientDetails.natname}</span>
                            </div>
                        </div>
                    </Flex>
                </Col>
                {/* <Col xs="auto" className="text-end">
                    <div className="text-white opacity-75 fs-11 mb-1">Status</div>
                    <Badge pill bg="success" className="fs-11 px-3">Active Patient</Badge>
                </Col> */}
            </Row>
        </Card.Header>
    );
};

export default PatientViewHeader;
